import PropTypes from "prop-types";
import React, { useState } from "react";
import { validateAttributes, errorMessage } from "../../utils/validations";
import { validations } from "./validations";
import { ToastContainer, toast } from "react-toastify";

const Name = (props) => {
  const [firstName, setFirstName] = useState(props.firstName || "");
  const [lastName, setLastName] = useState(props.lastName || "");

  const [errors, setErrors] = useState({});

  const updateName = async () => {
    const response = await fetch("/settings/update_name", {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
      body: JSON.stringify({
        user: {
          first_name: firstName,
          last_name: lastName,
        },
      }),
    });
    if (response.ok) {
      toast.success("Dane zostały zmienione pomyślnie!");
    } else {
      console.log("Error");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let validation = validateAttributes({ firstName, lastName }, validations);

    if (validation) {
      setErrors(validation);
      return;
    }

    updateName();
  };

  return (
    <>
      <ToastContainer position="top-center" />

      <form className="max-w-md">
        <div className="mb-4">
          <label className="block text-sm font-medium text-black mb-1">
            Imię
          </label>
          <input
            className="w-full border border-gray-300 px-3 py-2"
            onChange={(e) => setFirstName(e.target.value)}
            value={firstName}
          />

          {errorMessage(errors, "firstName")}
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-black mb-1">
            Nazwisko
          </label>
          <input
            className="w-full border border-gray-300 px-3 py-2"
            onChange={(e) => setLastName(e.target.value)}
            value={lastName}
          />

          {errorMessage(errors, "lastName")}
        </div>

        <button
          type="submit"
          className="bg-black text-white px-4 py-2 text-sm font-medium"
          onClick={handleSubmit}
        >
          Zapisz
        </button>
      </form>
    </>
  );
};

Name.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
};

export default Name;
